module.exports = __webpack_public_path__ + "img/passcode-lock.ec7fe02d.svg";